import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PslfFormSchema = withDefaults({
  type: 'pslf-form',
  objectExtensions: ['pslf-form'],
  fields: [
    {
      kind: 'attribute',
      name: 'status',
    },
    {
      kind: 'attribute',
      name: 'payrollId',
    },
    {
      kind: 'attribute',
      name: 'faxId',
    },
    {
      kind: 'attribute',
      name: 'borrowerFields',
    },
    {
      kind: 'attribute',
      name: 'employerFields',
    },
    {
      kind: 'attribute',
      name: 'borrowerCompletedAt',
    },
    {
      kind: 'attribute',
      name: 'employerCompletedAt',
    },
    {
      kind: 'attribute',
      name: 'submittedAt',
    },
    {
      kind: 'attribute',
      name: 'formType',
    },
    {
      kind: 'attribute',
      name: 'isNonPartner',
    },
    {
      kind: 'attribute',
      name: 'isPreApproved',
    },
    {
      kind: 'attribute',
      name: 'employerSignLink',
    },
    {
      kind: 'attribute',
      name: 'faxVerified',
    },
    {
      kind: 'attribute',
      name: 'submittedOnBehalfOfById',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'pslfTemplateId',
    },
    {
      kind: 'belongsTo',
      name: 'pslfProfile',
      type: 'pslf-profile',
      options: {
        async: false,
        inverse: 'pslfForms',
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'approverPslfProfile',
      type: 'pslf-profile',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'versions',
      type: 'pslf-form-version',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'pslfGroup',
      type: 'pslf-group',
      options: {
        async: false,
        inverse: 'pslfForms',
      },
    },
    {
      kind: 'belongsTo',
      name: 'pslfTemplate',
      type: 'pslf-template',
      options: {
        async: false,
        inverse: 'pslfForms',
      },
    },
  ],
});

export default PslfFormSchema;
